const pl = {
  "site.name": "Kakobuy Spreadsheet",
  "site.tagline": "Polska Baza Produktów 2026",
  "nav.home": "Strona Główna",
  "nav.categories": "Kategorie",
  "nav.articles": "Artykuły",
  "nav.guides": "Poradniki",
  "nav.comparisons": "Porównania",
  "hero.title": "Kakobuy Spreadsheet",
  "hero.subtitle": "Najlepsza Baza Produktów z Chin dla Polski",
  "hero.cta1": "Kakobuy Spreadsheet",
  "hero.cta2": "Buy It Now",
  "hero.slogan": "Kakobuy Spreadsheet",
  "hero.description": "Odkryj setki zweryfikowanych produktów — od sneakersów po akcesoria. Codzienna aktualizacja, bezpieczne linki i pełna ochrona kupującego.",
  "trust.title": "Dlaczego Kakobuy Spreadsheet?",
  "trust.stat1": "15+",
  "trust.stat1desc": "Kategorii Produktów",
  "trust.stat2": "5000+",
  "trust.stat2desc": "Zweryfikowanych Ofert",
  "trust.stat3": "Codziennie",
  "trust.stat3desc": "Aktualizacja Danych",
  "trust.desc1": "Aktualizowane codziennie",
  "trust.desc2": "Bezpieczne zakupy",
  "trust.desc3": "Zweryfikowane produkty",
  "categories.title": "Popularne Kategorie",
  "categories.cta": "Zobacz Wszystkie Kategorie",
  "categories.clothing": "Odzież i Komplety",
  "categories.clothingSub": "Sprawdź najnowsze dropsy",
  "categories.accessories": "Akcesoria i Dodatki",
  "categories.accessoriesSub": "Uzupełnij swój styl",
  "categories.other": "Paski, Perfumy i Inne",
  "categories.otherSub": "Wszystko czego potrzebujesz",
  "categories.all": "Pełny Katalog",
  "comparison.title": "Kakobuy vs Konkurencja",
  "comparison.kakobuy": "Kakobuy",
  "comparison.pandabuy": "Pandabuy",
  "comparison.sugargoo": "Sugargoo",
  "comparison.score": "Ocena",
  "comparison.rating": "Cena i Jakość",
  "comparison.service": "Obsługa Klienta",
  "comparison.shipping": "Wysyłka",
  "articles.title": "Poradniki i Artykuły",
  "articles.subtitle": "Baza Wiedzy Kakobuy",
  "articles.readMore": "Czytaj Więcej",
  "articles.guide": "Poradnik",
  "articles.comparison": "Porównanie",
  "faq.title": "FAQ – Najczęstsze Pytania",
  "faq.q1": "Czym jest Kakobuy Spreadsheet?",
  "faq.a1": "Kakobuy Spreadsheet to zaawansowana baza produktowa, która agreguje setki zweryfikowanych ofert z chińskich platform zakupowych w jednym miejscu. Dzięki regularnym aktualizacjom zawsze masz dostęp do najlepszych okazji.",
  "faq.q2": "Czy linki są bezpieczne?",
  "faq.a2": "Tak, wszystkie linki przekierowujące do kaspreadsheet.com są dokładnie weryfikowane. Każdy produkt przechodzi kontrolę jakości, a my regularnie usuwamy nieaktualne oferty, aby zapewnić bezpieczne zakupy.",
  "faq.q3": "Jak często aktualizowana jest baza?",
  "faq.a3": "Spreadsheet jest aktualizowany codziennie. Nasz zespół nieustannie monitoruje ceny, dostępność i jakość produktów, abyś zawsze otrzymywał aktualne informacje o najlepszych ofertach.",
  "faq.q4": "Jakie kategorie produktów obejmuje?",
  "faq.a4": "Nasza baza obejmuje szeroki zakres kategorii: obuwie (Shoes, Sneakers), odzież (Hoodies, T-Shirts, Jackets, Pants), akcesoria (Bags, Belts, Headwear), perfumy oraz wiele innych produktów lifestyle'owych.",
  "faq.q5": "Czy korzystanie ze Spreadsheet jest płatne?",
  "faq.a5": "Nie! Korzystanie z Kakobuy Spreadsheet jest całkowicie darmowe i nie wymaga żadnej rejestracji ani logowania. Wszystkie linki i informacje są dostępne bez żadnych opłat.",
  "faq.q6": "Jak bezpiecznie robić zakupy przez Spreadsheet?",
  "faq.a6": "Zakupy realizowane są przez oficjalny sklep kaspreadsheet.com, który zapewnia pełną ochronę kupującego. Zawsze porównuj ceny, czytaj opinie innych użytkowników i korzystaj wyłącznie ze zweryfikowanych linków z naszego arkusza.",
  "testimonial.quote": "Kakobuy Spreadsheet zaoszczędził mi setki godzin szukania produktów. Najlepsza polska baza ofert z Chin — przejrzysta, zawsze aktualna i całkowicie darmowa. Polecam każdemu, kto szuka jakościowych produktów w rozsądnych cenach!",
  "testimonial.name": "Anna K.",
  "testimonial.role": "Fashion Blogger, Warszawa",
  "testimonial.cta": "Zobacz Więcej Opinii",
  "cta.title": "gotowy na zakupy?",
  "cta.description": "Bezpieczne przekierowanie do oficjalnego katalogu. Pełna ochrona kupującego i zweryfikowane linki.",
  "cta.button": "Przejdź do Kaspreadsheet.com",
  "footer.categoriesTitle": "Kategorie",
  "footer.guidesTitle": "Poradniki",
  "footer.comparisonsTitle": "Porównania",
  "footer.faqTitle": "FAQ",
  "footer.copyright": "© 2026 kakobuyspreadsheet.watch",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "article.backHome": "← Powrót na stronę główną",
  "article.relatedTitle": "Powiązane Artykuły",
};

export default pl;